var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
export class DeliverPatientInvoiceResultDto {
    outcome;
    /** Set iff outcome is SKIPPED. */
    reason;
    /** The invoice's delivery fact after the attempt; set by the first delivering dispatch. */
    sentAt;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], DeliverPatientInvoiceResultDto.prototype, "outcome", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DeliverPatientInvoiceResultDto.prototype, "reason", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DeliverPatientInvoiceResultDto.prototype, "sentAt", void 0);
//# sourceMappingURL=deliver-patient-invoice-result.response.dto.js.map